import { CapoPlugin } from "/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];